import BookForm from "components/shared/book/form";
import { FilesField } from "components/shared/form";
import { serializeReq } from "helpers/form";
import { viewContainer } from "helpers/redux";
import React, { lazy, Suspense } from "react";
import { uploadFile } from "sources/books/platformNews";
import { config, initialState } from "../formConfig";

const Editor = lazy(() => import("components/shared/editor.js"));

class AdminPlatformNewsForm extends BookForm {
    renderBody = () => {
        const { header, section, flags } = this.props.config;
        return (
            <>
                {this.renderField(header)}
                {this.renderSelect(section)}
                {this.renderFlags(flags)}
                {this.renderFiles()}
                <Suspense fallback={<div className="loading" />}>
                    <Editor value={this.state.text} onChange={(value) => this.setValue({ name: "text", value })} />
                </Suspense>
            </>
        );
    };

    renderFiles = () => (
        <FilesField
            withoutDownload
            uploadFile={uploadFile}
            modal={this.props.modal}
            files={this.state.files}
            onChange={(files) => this.setState({ files, fileIds: files.map((file) => file.id) })}
        />
    );

    onSubmit = (e) => {
        e.preventDefault();
        const { isLoading, isValid, ...state } = this.state;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                delete state.files;
                return this.applyReq(serializeReq(state));
            }
            this.setState({ isValid: false });
        }
    };
}

const ConfiguredForm = (props) => <AdminPlatformNewsForm {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredForm, "admin-platform-news");
